export const TRACKING_EVENTS = {
  PAGE_VIEW: "PAGE_VIEW",
  SIGNUP_BUTTON_CLICKED: "SIGNUP_BUTTON_CLICKED",
  SIGNUP_WEBSITE_SUBMIT: "SIGNUP_WEBSITE_SUBMIT",
  SIGNUP_WEBSITE_SUCCESS: "SIGNUP_WEBSITE_SUCCESS",
  SIGNUP_WEBSITE_ERROR: "SIGNUP_WEBSITE_ERROR",
  BOOK_DEMO_BUTTON_CLICKED: "BOOK_DEMO_BUTTON_CLICKED",
  SIGNUP_COMPLETED: "SIGNUP_COMPLETED",
  ONBOARDING_COMPLETED: "ONBOARDING_COMPLETED",
  CHECKOUT_COMPLETED: "CHECKOUT_COMPLETED",
  REFERRALS_GET_FREE_CREDITS_CLICKED: "REFERRALS_GET_FREE_CREDITS_CLICKED",
  REFERRALS_REFER_COMPANY_CLICKED: "REFERRALS_REFER_COMPANY_CLICKED",
  REFERRALS_SEND_REFERRAL_CLICKED: "REFERRALS_SEND_REFERRAL_CLICKED",
  CAMPAIGN_CREATED: "CAMPAIGN_CREATED",
  CAMPAIGN_SIDEPANEL_OPENED: "CAMPAIGN_SIDEPANEL_OPENED",
  CAMPAIGN_UPDATED: "CAMPAIGN_UPDATED",
  CAMPAIGN_STATUS_UPDATED: "CAMPAIGN_STATUS_UPDATED",
  CAMPAIGN_LAUNCHED: "CAMPAIGN_LAUNCHED",
}
